export enum CustomerType {
    PRIVATE = "private",
    COMPANY = "company"
}

